import { CompanyProfile } from "../models/company.profile";
import BaseService from "./_base.service";

const endpoint = "profile/companies";

const ProfileCompanyService = {
  ...BaseService<CompanyProfile>({ endpoint })
};

export default ProfileCompanyService;
